import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../sections/Footer/Footer';
import { getBlogById } from '../../api/blogApi';
import './SingleBlog.scss';

const SingleBlog = () => {
  const { url } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        setLoading(true);
        // Try to find blog by slug/url first
        const blogData = await getBlogById(url);
        if (blogData) {
          setBlog(blogData);
        } else {
          setError('Blog not found');
        }
      } catch (err) {
        setError('Failed to load blog');
        console.error('Error fetching blog:', err);
      } finally {
        setLoading(false);
      }
    };

    if (url) {
      fetchBlog();
    }
  }, [url]);

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="container mt-5">
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error || !blog) {
    return (
      <>
        <Navbar />
        <div className="container mt-5">
          <div className="text-center">
            <h2>Blog Not Found</h2>
            <p>{error || 'The requested blog could not be found.'}</p>
            <Link to="/blogs" className="btn btn-primary">
              Back to Blogs
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const { title, image, content, category, created_at, author } = blog;

  return (
    <>
      <Navbar />
      <section className="section-bg pb-70 single-blog">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <main className="single-blog-area">
                <p className="single-blog-category">{category || 'DENTAL CARE'}</p>
                <h2 className="single-blog-title">{title}</h2>
                {image && (
                  <img
                    className="single-blog-banner"
                    src={image}
                    alt="blog banner"
                  />
                )}
                {author && (
                  <p className="single-blog-meta">
                    By {author} • {new Date(created_at).toLocaleDateString()}
                  </p>
                )}
                <div 
                  className="single-blog-content"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              </main>
            </div>
            <div className="col-lg-3">
              <div className="blog-sidebar">
                <div className="sidebar-subscribe mb-5">
                  <h3 className="sidebar-heading">Get Latest Updates</h3>
                  <form>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Subscribe to email"
                      />
                      <input
                        className="btn btn-primary mt-1 w-100"
                        type="button"
                        value="Subscribe"
                      />
                    </div>
                  </form>
                </div>

                <div className="sidebar-category mb-3">
                  <h3 className="sidebar-heading">Categories</h3>
                  <ul>
                    <li>
                      <Link to="/blogs?category=technology">Technology</Link>
                    </li>
                    <li>
                      <Link to="/blogs?category=root-canal">Root Canal</Link>
                    </li>
                    <li>
                      <Link to="/blogs?category=teeth">Teeth</Link>
                    </li>
                    <li>
                      <Link to="/blogs?category=whitening">Whitening</Link>
                    </li>
                    <li>
                      <Link to="/blogs?category=dentures">Dentures</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default SingleBlog;